// Homepage
export const UPDATE_MOBILE_HOMEPAGE_DATA = "homepage/UPDATE_MOBILE_HOMEPAGE_DATA";

// Product Details (Denomination)
export const ADD_NEW_DENOMINATION = "denomination/ADD_NEW_DENOMINATION";
export const REMOVE_AN_DENOMINATION = "denomination/REMOVE_AN_DENOMINATION";
export const SET_NEW_DENOMINATION = "denomination/SET_NEW_DENOMINATION";
export const UPDATE_QUANTITY_DENOMINATION = "denomination/UPDATE_QUANTITY_DENOMINATION";
export const WIPE_OUT_DENOMINATION = "denomination/WIPE_OUT_DENOMINATION";

// User Profile
export const UPDATE_USER_PROFILE = "userProfile/UPDATE_USER_PROFILE";

// Blogs
export const UPDATE_BLOGS = "blogs/UPDATE_BLOGS";
export const FETCH_BLOGS_REQUEST = "blogs/FETCH_BLOGS_REQUEST";
export const FETCH_BLOGS_SUCCESS = "blogs/FETCH_BLOGS_SUCCESS";
export const FETCH_BLOGS_FAILURE = "blogs/FETCH_BLOGS_FAILURE";

// Entertainment Products
export const UPDATE_ENTERTAINMENT_PRODUCTS = "entertainment/UPDATE_ENTERTAINMENT_PRODUCTS";

// Best Seller
export const UPDATE_BEST_SELLER_PRODUCTS = "bestSeller/UPDATE_BEST_SELLER_PRODUCTS";

// Category Select
export const SELECTED_CATEGORY = "category/SELECTED_CATEGORY";
export const DESELECTED_CATEGORY = "category/DESELECTED_CATEGORY";

// Featured Products
export const UPDATE_FEATURED_PRODUCTS = "featured/UPDATE_FEATURED_PRODUCTS";

// Fetch Slider
export const UPDATE_SLIDER_PRODUCTS = "fetchSlides/UPDATE_SLIDER_PRODUCTS";

// Giftcard Design
export const ADD_POST = 'ADD_POST';
export const REMOVE_POST = 'REMOVE_POST';
export const UPDATE_POST = 'UPDATE_POST';
export const RESET_POSTS = 'RESET_POSTS';
export const SET_SELECTED_POST = 'SET_SELECTED_POST';
export const TOGGLE_POST_SELECTION = 'TOGGLE_POST_SELECTION';
export const SET_DEFAULT_COVER = 'SET_DEFAULT_COVER';
export const RESET_TO_DEFAULT_COVER = 'RESET_TO_DEFAULT_COVER';
export const RECEIVER_USER_DETAILS = 'RECEIVER_USER_DETAILS';
export const RECEIVER_CHOOSED_PLATEFORM = 'RECEIVER_CHOOSED_PLATEFORM';
export const IS_USER_WANT_DESIGN_GIFTCARD = 'IS_USER_WANT_DESIGN_GIFTCARD';
export const SHOW_GIFT_DESIGN_PANEL = 'SHOW_GIFT_DESIGN_PANEL';
export const HIDE_GIFT_DESIGN_PANEL = 'HIDE_GIFT_DESIGN_PANEL';

// Notification
export const UPDATE_NOTIFICATION_REDUCER = "notification/UPDATE_NOTIFICATION_REDUCER";

// Product Info
export const SET_CURRENT_PRODUCT_DETAIL = "product/SET_CURRENT_PRODUCT_DETAIL";
export const REMOVE_CURRENT_PRODUCT_DETAIL = "product/REMOVE_CURRENT_PRODUCT_DETAIL";

// Products By Category
export const SET_CATEGORIZED_PRODUCTS = "product/SET_CATEGORIZED_PRODUCTS";
export const REMOVE_CATEGORIZED_PRODUCTS = "product/REMOVE_CATEGORIZED_PRODUCTS";

// Top Five
export const TOP_FIVE_PRODUCTS = "topFive/TOP_FIVE_PRODUCTS";

// User Balance
export const UPDATE_USER_BALANCE = "userBalance/UPDATE_USER_BALANCE";

// User Orders
export const UPDATE_USER_ORDER_REDUCER = "userOrder/UPDATE_USER_ORDER_REDUCER";

// User Statement
export const UPDATE_USER_STATEMENT_REDUCER = "userStatement/UPDATE_USER_STATEMENT_REDUCER";

// Category
export const UPDATE_CATEGORY_REDUCER = "categories/UPDATE_CATEGORY_REDUCER";

// Navbar
export const SET_NAVBAR_MENU = "navbar/SET_NAVBAR_MENU";


//  dashboard page
export const UPDATE_ALL_DASHBOARD_DATA = "dashboard/UPDATE_ALL_DASHBOARD_DATA";
export const DASHBOARD_ERROR = "error/DASHBOARD_ERROR";
export const RESET_DASHBOARD = "reset/RESET_DASHBOARD";
export const DASHBOARD_LOADING = "loading/DASHBOARD_LOADING";
